import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

export function useEventNames(): UseQueryResult<
  string[],
  AxiosError<ErrorResponse>
> {
  const { appId, envId } = useEnvironment();

  return useQuery({
    queryKey: commonQueryKeys.distinctEventNames(appId, envId),

    queryFn: () =>
      api
        .get<"/apps/:appId/events/by-name">(`/apps/${appId}/events/by-name`, {
          params: { envId: envId! },
        })
        .then((res) => res.data.events),
    enabled: !!appId && !!envId,
  });
}
